import apiClient from '@/services/AccountClient'

const state = () => ({})

const getters = {}

const actions = {
  getFeeGroups ({ commit }, profileId) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/profiles/${profileId}/fees/groups`
    )
  },
  assignFeeGroup ({ commit }, { profileId, feeGroupId, weight }) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/profiles/${profileId}/fees/groups/${feeGroupId}`,
      { weight }
    )
  },
  removeFeeGroup ({ commit }, { profileId, feeGroupId }) {
    return apiClient.sendRequest(
      'DELETE',
      `api/admin/v1/profiles/${profileId}/fees/groups/${feeGroupId}`
    )
  },
  searchFeeGroups ({ commit }, { search, omitIds }) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/fees/groups',
      { search: search, omitIds }
    )
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
